<template>
    <a-modal v-model:visible="selfvisible" title="新增收件地址" @ok="handleOk" cancel-text="取消" ok-text="确定"
        wrap-class-name="addressOk-modal add_address" @cancel="handleCancel">

        <a-form-item label="收件人:" name="username">
            <a-input placeholder="请输入收件人姓名" v-model:value="addressInfo.username" autocomplete="off" />
        </a-form-item>
        <a-form-item label="手机号码:" name="mobile">
            <a-input v-model:value="addressInfo.mobile" :maxlength="11" placeholder="请输入手机号码" />
        </a-form-item>
        <a-form-item label="所在区域:" name="city">
            <a-cascader :field-names="{ value: 'label' }" v-model:value="addressInfo.valueCity" @change="cityChange"
                :options="addressInfo.options" placeholder="请输入收货地址" />
        </a-form-item>
        <a-form-item label="详细地址:" name="address">
            <a-textarea v-model:value="addressInfo.address" :maxlength="30" />
        </a-form-item>
        <a-form-item class="default-form" label="" name="default">
            <a-checkbox v-model:checked="addressInfo.checked">设为默认地址</a-checkbox>
        </a-form-item>
    </a-modal>
</template>

<script>
import { defineComponent, ref, reactive } from "vue";
import optionCity from '@/assets/addressInfo/addressData.json'
import { addAddressFun } from '@/utils/request'
import { message } from 'ant-design-vue'


import './addAddress.less'
export default defineComponent({
    setup() {
        const selfvisible = ref(true);
        const addressInfo = reactive({
            username: '',
            mobile: '',
            checked: false,
            address: '',
            addr_province: '',
            addr_city: '',
            addr_district: '',
            options: optionCity, 
            isDefault:0,
            valueCity:[],

        })
        const handleOk = (e) => {
            console.log(e, '打开');

            if (addressInfo.username.length === 0) {
                message.error({
                    content: () => '姓名不可为空！',
                    class: 'message-error'
                })
                return false
            }
            const phoneNumer = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
            if (addressInfo.mobile.length !== 11) { // 手机号码
                message.error({
                    content: () => '请输入11位手机号！',
                    class: 'message-error'
                })
                return false
            }

            if (!phoneNumer.test(addressInfo.mobile)) {
                message.error({
                    content: () => '请输入正确手机号！',
                    class: 'message-error'
                })
                return false
            }


            if (addressInfo.address.length == 0) {
                message.error({
                    content: () => '请输入详细地址！',
                    class: 'message-error'
                })
                return false

            }
            if (addressInfo.checked) {
                addressInfo.isDefault = 1
            } else {
                addressInfo.isDefault = 0
            }
            let data = {
                addr_province: addressInfo.addr_province,
                addr_city: addressInfo.addr_city,
                addr_district: addressInfo.addr_district,
                addr_detail: addressInfo.address,
                mobile: addressInfo.mobile,
                consignee: addressInfo.username,
                is_default: addressInfo.isDefault,
            }
            addAddressFun(data).then(res =>{
                console.log(res,'res')
                if(res.code == 200){
                    message.error({
                        content: () => '添加成功',
                        class: 'message-success'
                    })
                    // selfvisible.value = false
                    window.parent.addadressModal.onClose()
                }

            }).catch(error=>{
                console.log(error)
            })
        };
        const handleCancel = (e) => {
            console.log(e, '关闭')
            console.log(window.parent,'parent')
            selfvisible.value = true
            window.parent.addadressModal.onClose()

        }
        const cityChange = (city) => {
            console.log(city, 'city')
            const [city1, city2, district] = city;
            addressInfo.addr_province = city1
            addressInfo.addr_city = city2
            addressInfo.addr_district = district

        }
  
     
        return {
            selfvisible,
            handleOk,
            cityChange,
            handleCancel,
            addressInfo,
        };
    },
});
</script>
